import { SECTION_FILL_CLASSES } from "components/sidebar/sidebarShell";
import CustomTableGrid from "routes/custom_tables/grid/CustomTableGrid";

// The grid an active linked tab renders: rows of `slug` pinned to those
// whose relationship column (`fieldId`) points at this record.
const LinkedTableView = ({ slug, fieldId, recordId }) => (
  <div className={`${SECTION_FILL_CLASSES} tw:pt-3.5`}>
    <CustomTableGrid
      slug={slug}
      lockedFilters={{ [fieldId]: Number(recordId) }}
    />
  </div>
);

export default LinkedTableView;
